import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import "./ServiceManager.css";

function ServiceManager() {
  const [services, setServices] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ title: "", category: "" });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");

  // Fetch all services
  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    const snap = await getDocs(collection(db, "services"));
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setServices(data);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this service?")) {
      await deleteDoc(doc(db, "services", id));
      fetchServices();
    }
  };

  const handleEdit = (srv) => {
    setEditId(srv.id);
    setForm({ title: srv.title, category: srv.category });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = null;
      if (image) imageUrl = await uploadToCloudinary(image);
      const newData = {
        title: form.title,
        category: form.category,
      };
      if (imageUrl) newData.image = imageUrl;

      await updateDoc(doc(db, "services", editId), newData);
      alert("Updated successfully!");
      setEditId(null);
      setForm({ title: "", category: "" });
      setImage(null);
      fetchServices();
    } catch (err) {
      console.error("Update failed:", err);
    }
    setLoading(false);
  };

  return (
    <div className="service-manager-page">
      <div className="manager-header">
        <h2>Manage Services / Category Images</h2>
        <div className="manager-actions">
          <input type="search" placeholder="Search services" value={query} onChange={e=>setQuery(e.target.value)} />
        </div>
      </div>

      {/* Edit section */}
      {editId && (
        <form className="edit-form" onSubmit={handleUpdate}>
          <input
            type="text"
            placeholder="Title"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Category"
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
            required
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />
          <button type="submit" disabled={loading}>
            {loading ? "Updating..." : "Save Changes"}
          </button>
        </form>
      )}

      {/* Services grid */}
      <div className="service-grid">
        {services.filter(s=> s.title.toLowerCase().includes(query.toLowerCase()) || (s.category||"").toLowerCase().includes(query.toLowerCase())).map((s) => (
          <div className="service-card" key={s.id}>
            <img src={s.image} alt={s.title} />
            <div className="card-info">
              <h4>{s.title}</h4>
              <p className="cat">{s.category}</p>
              <div className="actions">
                <button onClick={() => handleEdit(s)} className="icon-btn edit" aria-label={`Edit ${s.title}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor"/><path d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/></svg>
                </button>
                <button onClick={() => handleDelete(s.id)} className="icon-btn delete" aria-label={`Delete ${s.title}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceManager;